import {lazy} from "react";
import useTransHook from "./preloads/useTransHook";
import useRouteHook from "./preloads/useRouteHook";
import {languages} from "./config";
import useLangMatch from "./preloads/useLangMatch";
const Wrapper = lazy(() => import("./widgets/Wrapper"));
const LangSelect = lazy(() => import("./widgets/LangSelect"));

const exports = {
    routes: [

    ],
    preloads: [useLangMatch, useTransHook, useRouteHook],
    widgets: {
        LangSelect: LangSelect,
        Wrapper: Wrapper,
        languages: languages
    }
}
export default exports;